export const participantPassesApi = {
  participantPasses: {
    queryKey: (params?: string[]) => ["participant-passes", ...(params || [])],
    route: () => `participant-passes`,
    methods: ["GET", "POST"],
  },
  participantPass: {
    queryKey: (id: number, params?: string[]) => [
      "participant-passes",
      id,
      ...(params || []),
    ],
    route: (id: number) => `participant-passes/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
